import { FC } from 'react';
import Image, { ImageProps } from 'next/image';
import SvgBell from '@public/assets/uikit/icon/Bell.svg';
import SvgTextIndent from '@public/assets/uikit/icon/TextIndent.svg';
import SvgTextOutdent from '@public/assets/uikit/icon/TextOutdent.svg';

import SvgIconBook from './assets/_iconBook.svg';
import ArrowRight from './assets/ArrowRight.svg';
import SvgCaretRight from './assets/CaretRight.svg';
import PersonalIdNationalId from './assets/PersonalId_NationalId.svg';
import PersonalIdPassport from './assets/PersonalId_Passport.svg';
import BirthCertificate from './assets/personalIdentifiers/birth-certificate.svg';
import CitizenshipCertificate from './assets/personalIdentifiers/citizenship-certificate.svg';
import DriverLicense from './assets/personalIdentifiers/driver-license.svg';
import EducationCertificate from './assets/personalIdentifiers/education-certificate.svg';
import InternationalDriverPermit from './assets/personalIdentifiers/international-driver-permit.svg';
import MedicalId from './assets/personalIdentifiers/medical-id.svg';
import MilitaryId from './assets/personalIdentifiers/military-id.svg';
import NationalId from './assets/personalIdentifiers/national-id.svg';
import OtherId from './assets/personalIdentifiers/other-id.svg';
import Passport from './assets/personalIdentifiers/passport.svg';
import ResidencePermit from './assets/personalIdentifiers/residence-permit.svg';
import SocialSecurity from './assets/personalIdentifiers/social-security.svg';
import Substance from './assets/personalIdentifiers/substance.svg';
import TaxId from './assets/personalIdentifiers/tax-id.svg';
import PlayFilled from './assets/PlayFilled.svg';
import PlayFilledSmooth from './assets/PlayFilledSmooth.svg';
import SvgShare from './assets/Share.svg';
import SvgTarget from './assets/Target.svg';
import { IconName as PhIconName } from './types';

const extIconToSvgMap = {
  ['ArrowRight']: ArrowRight,
  ['Bell']: SvgBell,
  ['CaretRight']: SvgCaretRight,
  ['Share']: SvgShare,
  ['Target']: SvgTarget,
  ['TextIndent']: SvgTextIndent,
  ['TextOutdent']: SvgTextOutdent,

  ['_iconBook']: SvgIconBook,
  ['PersonalIdNationalId']: PersonalIdNationalId,
  ['PersonalIdPassport']: PersonalIdPassport,
  ['PlayFilled']: PlayFilled,
  ['PlayFilledSmooth']: PlayFilledSmooth,

  ['Passport']: Passport,
  ['NationalId']: NationalId,
  ['ResidencePermit']: ResidencePermit,
  ['BirthCertificate']: BirthCertificate,
  ['TaxId']: TaxId,
  ['EducationCertificate']: EducationCertificate,
  ['SocialSecurity']: SocialSecurity,
  ['MedicalId']: MedicalId,
  ['DriverLicense']: DriverLicense,
  ['InternationalDriverPermit']: InternationalDriverPermit,
  ['MilitaryId']: MilitaryId,
  ['FreeBlock']: OtherId,
  ['PersonalContacts']: OtherId,
  ['Substance']: Substance,
  ['UserDetails']: OtherId,
  ['CitizenshipCertificate']: CitizenshipCertificate,
};

type ExtIconName = keyof typeof extIconToSvgMap;
export type IconSize = 's80' | 's64' | 's44' | 's36' | 's32' | 's24' | 's20' | 's16' | 's12';
export type IconName = ExtIconName | PhIconName;

export type IconProps = Omit<ImageProps, 'width' | 'height' | 'alt' | 'src'> & {
  name: IconName;
  size?: IconSize;
};

export const Icon: FC<IconProps> = ({ name, size = 's24', className, ...props }) => {
  const iconData = name in extIconToSvgMap ? extIconToSvgMap[name as ExtIconName] : null;

  if (iconData) {
    return (
      <Image src={iconData} width={24} height={24} alt={name} className={className} {...props} />
    );
  } else {
    // TODO classnames
    const fontClassName = [`ph ph-${name} phsize-${size}`, className]
      .filter((item) => Boolean(item))
      .join(' ');

    return <i className={fontClassName} {...props} />;
  }
};
